import { Box } from '@mui/material';

const SectionCard = ({ children, sx = {} }) => {
	return (
		<Box
			sx={{
				padding: '20px',
				background: '#fff',
				borderRadius: '12px',
				border: '1px solid #E5E7EB',
				// boxShadow: '0 8px 22px rgba(34, 50, 64, 0.04)',
				...sx,
			}}
		>
			{children}
		</Box>
	);
};

export default SectionCard;
